import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pvPsv: [],
  pvPsvMap: {},
  loading: false
};

export const pvPsvSlice = createSlice({
  name: 'pvPsv',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPVPSV: (state, action) => {
      const { pvPsv, pvPsvMap } = action.payload || {};

      state.pvPsv = pvPsv;
      state.pvPsvMap = pvPsvMap;
    },
    setNewPSVFromStorage: (state, action) => {
      const { newPsvsList = [] } = action.payload;
      state.pvPsv = [...(state.pvPsv || []), ...newPsvsList];
    }
  }
});

const pvPsvReducer = pvPsvSlice.reducer;
export const pvPsvActions = pvPsvSlice.actions;
export default pvPsvReducer;
